export enum PropertyDisplayFormat {
  Date = "Date",
  DateTime = "DateTime",
  Currency = "Currency",
  Percent = "Percent",
  Number = "Number",
  Link = "Link",
  PhoneLink = "PhoneLink",
  EmailLink = "EmailLink",
}
